var _path, _rect, _rect2, _path2, _path3, _path4, _circle, _circle2, _circle3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUninstallLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 19H71V66H9C7.89543 66 7 65.1046 7 64V19Z",
    fill: "#D6F5E7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 13,
    y: 30,
    width: 13,
    height: 28,
    fill: "url(#paint0_linear_607_37331)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 31,
    y: 30,
    width: 31,
    height: 28,
    fill: "url(#paint1_linear_607_37331)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69 14H71C72.1046 14 73 14.8954 73 16V64C73 65.1046 72.1046 66 71 66H69V14Z",
    fill: "#AEDCC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69 14H71C72.1046 14 73 14.8954 73 16V24H69V14Z",
    fill: "#8AC4AA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16C7 14.8954 7.89543 14 9 14H69V24H7V16Z",
    fill: "#76D4A9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 19,
    r: 2,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 19,
    r: 2,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 19,
    r: 2,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_607_37331",
    x1: 13,
    y1: 30,
    x2: 13,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84D6B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97E3C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_607_37331",
    x1: 31,
    y1: 30,
    x2: 31,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84D6B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97E3C5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUninstallLogout);
export default __webpack_public_path__ + "static/media/uninstall_logout.9647849c5cf08ba76ca88bde0af40704.svg";
export { ForwardRef as ReactComponent };